
import { Star } from 'lucide-react';

interface TestimonialCardProps {
  name: string;
  role?: string;
  comment: string;
  rating: number;
  image?: string;
}

export const TestimonialCard = ({
  name,
  role,
  comment,
  rating,
  image,
}: TestimonialCardProps) => {
  return (
    <div className="glass-card p-8 hover-lift">
      <div className="flex items-center space-x-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={18}
            className={`${
              i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'
            }`}
          />
        ))}
      </div>
      <p className="mb-6 text-dental-text italic">{comment}</p>
      <div className="flex items-center">
        {image && (
          <img
            src={image}
            alt={name}
            className="w-12 h-12 rounded-full object-cover mr-4"
          />
        )}
        <div>
          <h4 className="font-medium text-dental-text">{name}</h4>
          {role && <p className="text-sm text-dental-muted">{role}</p>}
        </div>
      </div>
    </div>
  );
};
